import router from "./Router";
import { useTechStore } from "@/Store/TechStore";
import { useProjectStore } from "@/Store/ProjectStore";
import { ElMessage } from "element-plus";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getPageTitle } from "./Utils/UtilTools";
import { setPagestate } from "./Directive/AutoSavePageState/AutoSavePageStateFun";
import { apiGetUserInfo, apiGetUserInfoWithRedirt } from "@/Api/AppApi";

NProgress.configure({ showSpinner: false });

let techStore = null, projectStore = null;

// 只校验是否登录
const loginWhiteList = ['/mainpageindex', '/home', '/home/doc', '/d'];
const loginWhitePrefixList = ['/d/'];

router.beforeEach(async (to, from) => {
  if (to.path === from.path && to.hash !== from.hash) {
    // 只有hash改变
    return true;
  }

  NProgress.start();

  document.title = getPageTitle(to.meta.title);

  if (to.matched.length < 1) {
    // 路由fallback
    if (to.path.indexOf('/d/') > -1) {
      return { path: "/error/404" };
    } else {
      return { path: "/d" + to.path };
    }

  }

  if (to.path.startsWith('/error')) {
    // 错误页面，不记录不鉴权
    return true;
  }

  if (loginWhiteList.includes(to.path) || loginWhitePrefixList.some(v => to.path.startsWith(v))) {
    // 白名单不鉴权
    return true;
  }

  setPagestate("pageRouter", to.name);

  if (techStore === null) {
    techStore = useTechStore();
    projectStore = useProjectStore();
  }

  if (techStore.userInfo === null) {
    const res = await apiGetUserInfo();
    if (res.code === 0) {
      if (res.data !== null) {
        techStore.changeUserInfo(res.data);
        return true;
      } else {
        ElMessage.error("请先登录");
        apiGetUserInfoWithRedirt();
        return true;
      }
    } else {
      // ElMessage.error(res.message);
      return { path: "/error/404" };
    }
  } else {
    if (!to.query.project && projectStore.currentProjectId) {
      // 按钮进入控制台/无权限跳转 后 query被清空，补充参数
      to.query.project = projectStore.currentProjectId;
      return to;
    } else {
      return true;
    }
  }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
